<template>
  <div class="god_page_container">
    <h2>Planes</h2>
    <div id="selector_container">
      <select 
        v-model="modo"
        @change="getAllPlans()"
        class="input_200">
        <option value="0">Planes vigentes</option>
        <option value="1">Planes caducados</option>
        <option value="2">Planes eliminados</option>
      </select>

      <select 
        v-model="tipo"
        class="input_200">
        <option value="0">Plan de profesional</option>
        <option value="1">Plan de particular</option>
        <option value="2">Tarjeta regalo</option>
      </select>

      <input
        type="text"
        class="input_200"
        v-model="planId"
        placeholder="ID del plan"
      />


      <input
        type="text"
        class="input_200"
        v-model="planTitle"
        placeholder="Título del plan"
      />


      <input
        type="text"
        class="input_200"
        v-model="companyName"
        placeholder="Nombre de la empresa"
      />

      <input
        type="date"
        v-model="planDate"
        class="input_200"
        placeholder="Fecha del plan"
      />

      <select 
        v-model="ciudad"
        class="input_200"
        :style="{ color: ciudad === '' ? 'var(--text-color-placeholder)' : '' }">
        <option value="">Ciudad</option>
        <option value="Donosti">Donosti</option>
        <option value="Logroño">Logroño</option>
        <option value="Pamplona">Pamplona</option>
        <option value="Pirineo Aragones">Pirineo Aragonés</option>
        <option value="Valencia">Valencia</option>
        <option value="Zaragoza">Zaragoza</option>
      </select>

      <div class="input_200" style="display: flex; justify-content: flex-end; align-items: center; padding: 0; background: none; border: none;">
        <button @click="addPlan()" class="main_button" style="width: 100%; height: 100%;">
          Crear nuevo plan
          <img class="action_icon_white" src="@/assets/images/ic_add.png" />
        </button>
      </div>
    </div>
    <div class="table-container">
      <table>
        <thead>
          <tr>
              <th class="small" @click="setSort('ciudad')">Ciudad</th>
              <th class="small" @click="setSort('id')">Id del Plan</th>
              <th class="small">Tipo</th>
              <th class="big" @click="setSort('titulo')">Título</th>
              <th class="small" @click="setSort('fecha_fin')">Fecha fin</th>
              <th class="small" @click="setSort('fecha_validez')">Canjeable hasta</th>
              <th class="big" @click="setSort('empresa')">Empresa</th>
              <th class="small">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr 
            v-for="(item, index) in plans
            .filter(plan => {
              let estado;
              if (modo === '0') estado = 'vigente';
              else if (modo === '1') estado = 'caducado';
              else if (modo === '2') estado = 'cancelado';

              let filterTipo;
              if (tipo === '0') filterTipo = 'promo';
              else if (tipo === '1') filterTipo = 'plan';
              else if (tipo === '2') filterTipo = 'gift_card';

              return (plan.titulo.toLowerCase().includes(planTitle.toLowerCase()) || planTitle === '') &&
                    (plan.empresa.toLowerCase().includes(companyName.toLowerCase()) || companyName === '') &&
                    (plan.id.toString().toLowerCase().includes(planId.toLowerCase()) || planId === '') &&
                    (plan.ciudad.toLowerCase().includes(ciudad.toLowerCase()) || ciudad === '') &&
                    (fechaExiste(plan.fechas, planDate) || planDate === '') &&
                    plan.tipo === filterTipo &&
                    plan.estado === estado;
            }).sort((a, b) => {
              let modifier = 1;
              if (sortDirection === 'desc') modifier = -1;
              if (sortColumn === 'fecha_fin' || sortColumn === 'fecha_validez') {
                const [diaA, mesA, anioA] = a[sortColumn].split('/').map(Number);
                const [diaB, mesB, anioB] = b[sortColumn].split('/').map(Number);
                const dateA = new Date(anioA, mesA - 1, diaA);
                const dateB = new Date(anioB, mesB - 1, diaB);
                if (dateA < dateB) return -1 * modifier;
                if (dateA > dateB) return 1 * modifier;
                return 0;
              } else {
                if (a[sortColumn] < b[sortColumn]) return -1 * modifier;
                if (a[sortColumn] > b[sortColumn]) return 1 * modifier;
                return 0;
              }
            })"
            :key="item.id"
            :class="index % 2 === 0 ? 'bg-gray-100' : 'bg-white'"
          >
            <td>{{ item.ciudad }}</td>
            <td>{{ item.id }}</td>
            <td>{{ traducirTipo(item.tipo, item.flash) }}</td>
            <td>{{ item.titulo }}</td>
            <td><span v-if="esFechaProxima(item.fecha_fin) && modo === '0'">🚨</span>{{ item.fecha_fin }}<span v-if="esFechaProxima(item.fecha_fin) && modo === '0'">🚨</span></td>
            <td>{{ item.fecha_validez }}</td>
            <td>{{ item.empresa }}</td>
            <td>
              <img class="action_icon" src="@/assets/images/ic_reservation_visit.png" @click="onVisitClicked(item)"/>
              <img class="action_icon" src="@/assets/images/ic_reservation_edit.png" @click="onEditClicked(item)"/>
              <img v-if="item.tipo !== 'gift_card'" class="action_icon" src="@/assets/images/ic_action_participants.png" @click="onParticipantsClicked(item)"/>
              <img v-if="item.tipo === 'promo' || item.tipo === 'gift_card'" class="action_icon" src="@/assets/images/ic_action_clone.png" @click="onCloneClicked(item)"/>
              <img v-if="item.tipo === 'plan'" class="action_icon" src="@/assets/images/ic_action_comments.png" @click="onCommentsClicked(item)"/>
              <img class="action_icon" src="@/assets/images/ic_action_delete.png" @click="onHideClicked(item)"/>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <PlanParticularDetailsPopup
      :plan="selectedParticularPlanDetails" 
      @planParticularChanged="onParticularPlanChanged"
      @planParticularDetailsPopupCancelled="onPlanParticularDetailsPopupCancelled"
      @planParticularDetailsErrorHappened="onPlanParticularDetailsErrorHappened"
      />

    <PlanParticularParticipantsPopup
      :planName="selectedParticularPlanParticipantsName"
      :planId="selectedParticularPlanParticipantsId"
      :participants="selectedParticularPlanParticipants" 
      />

    <PlanParticularCommentsPopup
      :planName="selectedParticularPlanCommentsName"
      :planId="selectedParticularPlanCommentsId"
      :comments="selectedParticularPlanComments" 
      />

    <PlanDetailsPopup
      :plan="selectedPlanDetails"
      @planChanged="onPlanChanged"
      @planDetailsPopupCancelled="onPlanDetailsPopupCancelled"
      @planDetailsErrorHappened="onPlanDetailsErrorHappened"
      />

    <TwoButtonPopup
      :title="twoButtonTitle"
      :message="twoButtonMessage"
      :acceptButton="twoButtonAcceptButton"
      @acceptCallback="() => twoButtonConfirmed()"
      :cancelButton="twoButtonCancelButton"
      @cancelCallback="() => twoButtonCancelled()"
      />

    <ErrorPopup :errorMessage="error" />

  </div>
</template>

<script setup>
  import { ref, nextTick, watch } from 'vue'
  import { useLoadingStore } from "@/stores/loadingStore";
  import { useRouter, useRoute } from 'vue-router';
  import { refreshToken } from "@/services/authService";
  import ErrorPopup from "@/components/common/ErrorPopup.vue";
  import PlanDetailsPopup from "@/components/plans/PlanDetailsPopup.vue";
  import TwoButtonPopup from "@/components/common/TwoButtonPopup.vue";
  import PlanParticularDetailsPopup from './PlanParticularDetailsPopup.vue';
  import PlanParticularParticipantsPopup from './PlanParticularParticipantsPopup.vue';
  import PlanParticularCommentsPopup from './PlanParticularCommentsPopup.vue';

  const error = ref(null);
  const plans = ref([]);
  const loadingStore = useLoadingStore();
  const router = useRouter();
  const route = useRoute();

  const modo = ref(route.query.modo || '0');
  const tipo = ref(route.query.tipo || '0');
  const ciudad = ref(route.query.ciudad || '');
  const planTitle = ref(route.query.planTitle || '');
  const planId = ref(route.query.planId || '');
  const planDate = ref(route.query.planDate || '');
  const companyName = ref(route.query.companyName || '');
  const selectedPlanDetails = ref(null);
  const selectedParticularPlanDetails = ref(null);
  const selectedParticularPlanCommentsName = ref("");
  const selectedParticularPlanCommentsId = ref(0);
  const selectedParticularPlanComments = ref(null);
  const selectedParticularPlanParticipantsName = ref("");
  const selectedParticularPlanParticipantsId = ref(0);
  const selectedParticularPlanParticipants = ref(null);

  const twoButtonTitle = ref("");
  const twoButtonMessage = ref("");
  const twoButtonAcceptButton = ref("");
  const twoButtonCancelButton = ref("");
  let twoButtonConfirmed = null;
  let twoButtonCancelled = null;
  
  const sortColumn = ref(route.query.sortColumn || 'fecha_fin');
  const sortDirection = ref(route.query.sortDirection || 'asc');

  watch([modo, tipo, ciudad, planTitle, planId, planDate, companyName, sortColumn, sortDirection], () => {
    router.replace({
      query: {
        ...route.query,
        modo: modo.value,
        tipo: tipo.value,
        ciudad: ciudad.value,
        planTitle: planTitle.value,
        planId: planId.value,
        planDate: planDate.value,
        companyName: companyName.value,
        sortColumn: sortColumn.value,
        sortDirection: sortDirection.value,
      }
    });
  });

  const getAllPlans = async () => {
    loadingStore.setLoading(true);
    error.value = null;

    try {
      let response = await getAllPlansInAPI();

      if (response.status === 401) {
        const refreshed = await refreshToken();
        if (refreshed) {
          response = await getAllPlansInAPI();
        } else {
          loadingStore.setLoading(false);
          localStorage.removeItem('user_id');
          localStorage.removeItem('token');
          router.push('/');
          return;
        }
      }

      if (!response.ok) {
        showError("Se ha producido un error obteniendo los planes.");
        return;
      }

      const data = await response.json();

      if (data.errors) {
        error.value = data.message;
        plans.value = [];
      } else {
        error.value = null;
        plans.value = data.planes;
      }
    } catch (exception) {
      error.value = exception.message;
    } finally {
      loadingStore.setLoading(false);
    }
  };

  const setSort = (column) => {
    if (sortColumn.value === column) {
      sortDirection.value = sortDirection.value === 'asc' ? 'desc' : 'asc';
    } else {
      sortColumn.value = column;
      sortDirection.value = 'asc';
    }
  };

  async function getAllPlansInAPI() {
    let status;
    if (modo.value === '0') status = 'vigente';
    else if (modo.value === '1') status = 'caducado';
    else if (modo.value === '2') status = 'cancelado';

    return await fetch(process.env.VUE_APP_API_URL+"api/god/plans/get?user_id="+localStorage.getItem('user_id')+"&status="+status, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "vgod": process.env.VUE_APP_API_VGOD,
          "cp-token": process.env.VUE_APP_API_CP_TOKEN,
          "Authorization": "Bearer " + localStorage.getItem('token')
        },
      });
  }

  const showError = async (message) => {
    error.value = null;
    await nextTick(); // Espera a que Vue reaccione al cambio
    error.value = message;
  };

  function traducirTipo(tipo, isFlash) {
    switch (tipo) {
      case 'plan':
        return 'Particular';
      case 'promo':
        if (isFlash) {
          return "⚡️Profesional⚡️"
        } else {
          return 'Profesional';
        }
      case 'gift_card':
        return 'Tarjeta regalo';
      default:
        return tipo;
    }
  }

  function esFechaProxima(fechaStr) {
    const [dia, mes, anio] = fechaStr.split('/').map(Number)
    const fecha = new Date(anio, mes - 1, dia) // Mes empieza en 0 (enero)

    const hoy = new Date()
    hoy.setHours(0, 0, 0, 0) // Opcional: quitar horas para comparación solo por fecha

    const unaSemanaDespues = new Date(hoy)
    unaSemanaDespues.setDate(hoy.getDate() + 7)

    return fecha <= unaSemanaDespues
  }

  const onVisitClicked = (item) => {
    if (item.url) {
      window.open(item.url, '_blank');
    }
  };

  const onEditClicked = (item) => {
    getPlanDetails(item.id, item.tipo === 'promo' || item.tipo === 'gift_card', "edit");
  };

  const onParticipantsClicked = (item) => {
    if (item.tipo === 'promo') {
      router.push({ name: 'Reservations', query: { planId: item.id, planDate: planDate.value } });
    } else {
      getPlanDetails(item.id, false, "participants");
    }
  };

  const onCloneClicked = (item) => {
    getPlanDetails(item.id, true, "clone");
  }

  const onCommentsClicked = (item) => {
    getPlanDetails(item.id, false, "comments");
  };

  const onHideClicked = async (item) => {
    twoButtonTitle.value = item.estado === 'cancelado' ? "Mostrar plan" : "Ocultar plan";
    twoButtonMessage.value = item.estado === 'cancelado' ? "¿Estás seguro de que deseas mostrar este plan?" : "¿Estás seguro de que deseas ocultar este plan?";
    twoButtonAcceptButton.value = "Aceptar";
    twoButtonCancelButton.value = "Cancelar";
    if (item.estado !== 'cancelado' && item.tiene_participantes) {
      twoButtonMessage.value += "\n\n🚨🚨Este plan tiene participantes.🚨🚨";
    }
    twoButtonConfirmed = () => {
      twoButtonTitle.value = "";
      twoButtonMessage.value = "";
      twoButtonAcceptButton.value = "";
      twoButtonCancelButton.value = "";
      changePlanVisibilityConfirmed(item);
    };
    twoButtonCancelled = () => {
      twoButtonTitle.value = "";
      twoButtonMessage.value = "";
      twoButtonAcceptButton.value = "";
      twoButtonCancelButton.value = "";
    }
  }

  const changePlanVisibilityConfirmed = async (item) => {
    loadingStore.setLoading(true);
    error.value = null;

    try {
      let response = await changePlanVisibilityInAPI(item);

      if (response.status === 401) {
        const refreshed = await refreshToken();
        if (refreshed) {
          response = await changePlanVisibilityInAPI();
        } else {
          loadingStore.setLoading(false);
          localStorage.removeItem('user_id');
          localStorage.removeItem('token');
          router.push('/');
          return;
        }
      }

      if (!response.ok) {
        showError("Se ha producido un error cambiando el estado del plan.");
        return;
      }

      const data = await response.json();

      if (data.errors) {
        error.value = data.message;
      } else {
        error.value = null;
      }
    } catch (exception) {
      error.value = exception.message;
    } finally {
      getAllPlans();
    }
  };

  const changePlanVisibilityInAPI = async (item) => {
    return await fetch(process.env.VUE_APP_API_URL+"api/god/plans/edit_visibility", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "vgod": process.env.VUE_APP_API_VGOD,
          "cp-token": process.env.VUE_APP_API_CP_TOKEN,
          "Authorization": "Bearer " + localStorage.getItem('token')
        },
        body: JSON.stringify({
          "user_id": localStorage.getItem('user_id'),
          "plan_id": item.id,
          "visibility": item.estado === 'cancelado' ? 1 : 0 
        }),
      });
  };

  const getPlanDetails = async (itemId, isPromo, action) => {
    loadingStore.setLoading(true);
    error.value = null;

    try {
      let response = await getPlanDetailsInAPI(itemId);

      if (response.status === 401) {
        const refreshed = await refreshToken();
        if (refreshed) {
          response = await getPlanDetailsInAPI(itemId);
        } else {
          loadingStore.setLoading(false);
          localStorage.removeItem('user_id');
          localStorage.removeItem('token');
          router.push('/');
          return;
        }
      }

      if (!response.ok) {
        showError("Se ha producido un error cargando la información del plan.");
        return;
      }

      const data = await response.json();

      if (data.errors) {
        showError(data.message);
        plans.value = [];
      } else if (isPromo) {
        error.value = null;
        if (action == "clone") {
          data.plan.id_promo = 0;
          data.plan.campos_pedir.forEach(item => {
            item.id_campo = 0;
          });
          data.plan.productos.forEach(item => {
            item.id_producto_promo = 0;
            item.id_promo = 0;
            item.tiene_participantes = false;
          });
        }
        selectedPlanDetails.value = data.plan;
      } else if (action == "participants") {
        selectedParticularPlanParticipantsName.value = data.plan.nombre;
        selectedParticularPlanParticipantsId.value = data.plan.id_plan;
        selectedParticularPlanParticipants.value = data.plan.participantes;
      } else if (action == "comments") {
        selectedParticularPlanCommentsName.value = data.plan.nombre;
        selectedParticularPlanCommentsId.value = data.plan.id_plan;
        selectedParticularPlanComments.value = data.plan.comentarios;
      } else {
        selectedParticularPlanDetails.value = data.plan;
      }
    } catch (exception) {
      showError(exception.message);
    } finally {
      loadingStore.setLoading(false);
    }
  };

  const getPlanDetailsInAPI = async (itemId)=> {
    return await fetch(process.env.VUE_APP_API_URL+"api/god/plans/get_details?user_id="+localStorage.getItem('user_id')+"&plan_id="+itemId, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "vgod": process.env.VUE_APP_API_VGOD,
          "cp-token": process.env.VUE_APP_API_CP_TOKEN,
          "Authorization": "Bearer " + localStorage.getItem('token')
        }
      });
  };

  const onPlanDetailsPopupCancelled = () => {
    selectedPlanDetails.value = null;
  };

  const onPlanParticularDetailsPopupCancelled = () => {
    selectedParticularPlanDetails.value = null;
  };
  
  const onPlanDetailsErrorHappened = (message) => {
    showError(message);
  }

  const onPlanParticularDetailsErrorHappened = (message) => {
    showError(message);
  }

  const onPlanChanged = () => {
    selectedPlanDetails.value = null;
    getAllPlans();
  }

  const onParticularPlanChanged = () => {
    selectedParticularPlanDetails.value = null;
    getAllPlans();
  }

  const addPlan = () => {
    selectedPlanDetails.value = {
        "id_promo": 0,
        "nombre": "",
        "nombre_web": "",
        "descripcion": "",
        "etiqueta": "",
        "etiqueta_origen": "",
        "direccion": "",
        "online": false,
        "foto_video": "",
        "texto_boton": "",
        "enlace_boton": "",
        "tipo_boton": "",
        "categoria": "",
        "subcategoria_slug": "",
        "ciudad": "",
        "fecha_fin": "",
        "hora_fin": "",
        "flash": false,
        "fecha_validez": "",
        "tiene_datos": false,
        "descripcion_datos": "",
        "eliminado": true,
        "email_empresa": "",
        "orden": 0,
        "boton_pospago": "",
        "gastos_gestion_empresa": "0",
        "gastos_gestion_usuario": "0",
        "mostrar_cualquier_lugar": false,
        "descripcion_corta": "",
        "es_regalo": false,
        "texto_regalo": "",
        "fun_plan": false,
        "destacadisimo": false,
        "cantidad_obligatorios": 0,
        "etiqueta_personalizada": "",
        "envio_correo_confirmacion": false,
        "uso_cupon": false,
        "productos": [],
        "imagenes": [],
        "campos_pedir": [],
        "ciudad_key": "",
        "festivos": "",
        "otros_items": "",
        "otras_categorias": [],
        "seo_robots": "",
        "seo_canonical": "",
        "seo_json_data": "",
        "seo_keywords": "",
    }
  }

  const fechaExiste = (fechas, planDate) => {
    if (!Array.isArray(fechas) || !planDate) return false;

    const partes = planDate.split('-');
    if (partes.length === 3) {
      const [anio, mes, dia] = partes;
      const fechaPromo = `${dia}-${mes}-${anio}`;
      const fechaPlan = `${dia}/${mes}/${anio}`;
      return fechas.includes(planDate) || fechas.includes(fechaPromo) || fechas.includes(fechaPlan);
    }

    return fechas.includes(planDate);
  };

  getAllPlans();

</script>

<style scoped>

#selector_container {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding-top: 1rem;
  justify-content: space-between;
}

@media (max-width: 768px) {
  #selector_container > * {
    flex: none !important;
  }

  .input_200 {
    width: 100%;
  }

  table {
    width: 100%;
    min-width: 0px;
  }

}

.input_200 {
  box-sizing: border-box;
  min-width: 200px;
  flex: 1 1 200px;
  padding: 8px;
  width: 100%;
  line-height: 1.2;
  height: 50px;
  max-height: 50px;
}

.table-container {
  overflow-x: auto;
  width: 100%;
}

table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 30px;
  min-width: 800px; /* evita que se aplaste */
}

th {
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 5px;
  padding-right: 5px;
  background-color: var(--gray);
  color: white;
  border: 0px;
}

tfoot {
  background-color: var(--gray);
  color: white;
  border: 0px;
}
.big {
  width: 20%;
}

.small {
  width: 10%;
}

tr{
  cursor: pointer;
}

td {
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 5px;
  padding-right: 5px;
}

.bg-gray-100 {
  background-color: var(--almost-white);
}

.bg-white {
  background-color: white;
}

.action_icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin: 0px 5px;
}

.action_icon_white {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-left: 10px;
  filter: brightness(0) invert(1);
}

</style>
